import React from 'react'
import LandingLayout from '../../components/Layouts/LandingLayout'
import AboutContainer from '../../modules/Portafolio/About/About.container'
import ExperienceContainer from '../../modules/Portafolio/Experience/Experience.container'
import HeaderContainer from '../../modules/Portafolio/Header/Header.container'
import ProfileContainer from '../../modules/Portafolio/Profile/Profile.container'
import ProjectContainer from '../../modules/Portafolio/Project/Project.container'
import SkillsContainer from '../../modules/Portafolio/Skills/Skills.container'
import FooterContainer from '../../modules/Portafolio/Footer/Footer.container'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'
import { PROJECT_KINDS } from '../../modules/Portafolio/Project/project.model'

/*
 * The Portfolio Home's page
 */
const Landing = (props) => {
  return (
    <LandingLayout header={<HeaderContainer />} footer={<FooterContainer />}>
      <ProtectByFeatures
        fallback={() => <p>Esta sección no se encuentra activa</p>}
        rule={features => features['project.section']}
      >
        <ProfileContainer />
      </ProtectByFeatures>
      <ProtectByFeatures rule={features => features['about.me.section']}>
        <AboutContainer />
      </ProtectByFeatures>
      <SkillsContainer />
      <ExperienceContainer />
      <ProtectByFeatures
        fallback={() => <p>Esta sección no se encuentra activa</p>}
        rule={features => features['project.section']}
      >
        <ProjectContainer kind={PROJECT_KINDS.PERSONAL} />
        <ProjectContainer kind={PROJECT_KINDS.PRACTICE} />
      </ProtectByFeatures>
    </LandingLayout>
  )
}

export default Landing
